"use strict";

/**
 * Displays a pattern validation error for an input.
 * @param {jQuery} $input - Input element wrapped by jQuery.
 * @returns {void}
 */
function showInputRegexError($input) {
    if (!$input) {
        return;
    }

    $input.addClass("is-invalid");
    $input.siblings(".invalid-feedback").text($input.data("pattern-mismatch") || "");
}

/**
 * Clears pattern validation error state from an input.
 * @param {jQuery} $input - Input element wrapped by jQuery.
 * @returns {void}
 */
function clearInputRegexError($input) {
    if (!$input) {
        return;
    }

    $input.removeClass("is-invalid");
    $input.siblings(".invalid-feedback").text("");
}

/**
 * Builds a safe RegExp from a pattern string.
 * @param {string} regexPattern - Pattern string from the input attribute.
 * @returns {RegExp|null} A RegExp instance or null when the pattern is invalid.
 */
function createSafeRegex(regexPattern) {
    try {
        return new RegExp(regexPattern);
    } catch (e) {
        return null;
    }
}

/**
 * Restricts input to numeric characters and validates against the field pattern.
 * @param {jQuery} $numericInput - Numeric input(s) wrapped by jQuery.
 * @returns {void}
 */
function validateNumericInput($numericInput) {
    if (!$numericInput || !$numericInput.length) {
        return;
    }

    $numericInput.each(function () {
        $(this)
            .off("input.validateForm blur.validateForm") // remove listeners that may be added more than once to the same element
            .on("input.validateForm", function () {
                this.value = this.value.replace(/[^0-9]/g, "");
            })
            .on("blur.validateForm", function () {
                var $this = $(this);
                var value = $this.val();
                var regexPattern = $this.attr("pattern");

                if (!regexPattern || !value.length) {
                    if ($this.hasClass("is-invalid")) {
                        clearInputRegexError($this);
                    }

                    return;
                }

                var regex = createSafeRegex(regexPattern);
                if (!regex) {
                    showInputRegexError($this);
                    return;
                }

                if (regex.test(value)) {
                    clearInputRegexError($this);
                } else {
                    showInputRegexError($this);
                }
            });
    });
}

/**
 * Restricts input to alphanumeric characters and validates against the field pattern.
 * @param {jQuery} $textInput - Text input(s) wrapped by jQuery.
 * @returns {void}
 */
function validateNoSpecialCharacter($textInput) {
    if (!$textInput || !$textInput.length) {
        return;
    }

    $textInput.each(function () {
        $(this)
            .off("input.validateForm blur.validateForm") // remove listeners that may be added more than once to the same element
            .on("input.validateForm", function () {
                this.value = this.value.replace(/[^A-Za-z0-9]/g, "");
            })

            .on("blur.validateForm", function () {
                var $this = $(this);
                var value = $this.val();
                var regexPattern = $this.attr("pattern");

                if (!regexPattern || !value.length) {
                    if ($this.hasClass("is-invalid")) {
                        clearInputRegexError($this);
                    }

                    return;
                }

                var regex = createSafeRegex(regexPattern);
                if (!regex) {
                    showInputRegexError($this);
                    return;
                }

                if (regex.test(value)) {
                    clearInputRegexError($this);
                } else {
                    showInputRegexError($this);
                }
            });
    });
}

/**
 * Initializes numeric validation behavior for phone fields.
 * @returns {void}
 */
function validatePhone() {
    var $phoneInput = $(".js-phone-validator");
    if (!$phoneInput || !$phoneInput.length) {
        return;
    }

    validateNumericInput($phoneInput);
}

/**
 * Initializes numeric validation behavior for area code fields.
 * @returns {void}
 */
function validateAreaCode() {
    var $areaCodeInput = $(".js-area-code-validator");
    if (!$areaCodeInput || !$areaCodeInput.length) {
        return;
    }

    validateNumericInput($areaCodeInput);
}

/**
 * Initializes numeric validation behavior for document number fields.
 * @returns {void}
 */
function validateDocNumber() {
    var $docNumberInput = $(".js-doc-number-validator");
    if (!$docNumberInput || !$docNumberInput.length) {
        return;
    }

    validateNumericInput($docNumberInput);
}

/**
 * Initializes alphanumeric validation behavior for postal code fields.
 * @returns {void}
 */
function validatePostalCode() {
    var $postalCodeInput = $(".js-postal-code-validator");
    if (!$postalCodeInput || !$postalCodeInput.length) {
        return;
    }

    validateNoSpecialCharacter($postalCodeInput);
}

/**
 * Initializes all custom input validators used in forms.
 * @returns {void}
 */
function validateFormInput() {
    validatePhone();
    validateAreaCode();
    validateDocNumber();
    validatePostalCode();
}

module.exports = {
    validateFormInput: validateFormInput
};
